import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { filter, map, switchMap, take } from 'rxjs/operators';
import { UiSettingsService } from '@app/core/services/ui-settings.service';
import { ModuleKey, firstEnabledModule } from '@app/models/ui-settings.model';

export const moduleEnabledGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const settings = inject(UiSettingsService);
  const router = inject(Router);
  const key = route.data['moduleKey'] as ModuleKey;

  // Wait until the first refresh has settled (success or failure) so we read
  // the real server state, not the DEFAULT_UI_SETTINGS placeholder.
  return settings.loaded$.pipe(
    filter(loaded => loaded),
    take(1),
    switchMap(() => settings.state$.pipe(take(1))),
    map(s => {
      if (s.enabledModules[key]) return true;
      const fallback = firstEnabledModule(s);
      return router.parseUrl(fallback ? `/bookings/${fallback}` : '/settings');
    }),
  );
};
